import React from 'react'
import classNames from 'classnames'
import { Campaign } from '@/services/api/campaign'
import CampaignCard from '../CampaignCard'
import Lozenge from '../Lozenge'
import Type from '../Type'

interface Props {
  campaigns: Campaign[]
  className?: string
  preTitle?: string
  subtitle?: string
  text?: string
  title: string
}

export const CampaignSection: React.FC<Props> = ({
  campaigns,
  className,
  preTitle,
  subtitle,
  text,
  title,
  ...rest
}) => {
  return (
    <div
      className={classNames('w-full max-w-[1168px] px-4', className)}
      {...rest}
    >
      {preTitle && <Lozenge className="mb-1">{preTitle}</Lozenge>}
      <Type
        as="h2"
        variant={['heading-xs', 'md:heading-xl']}
        className="font-bold md:mr-2"
      >
        {title}
      </Type>
      {subtitle && (
        <Type
          as="p"
          variant={['title-xs', 'md:title-lg']}
          className="text-core-gray-700"
        >
          {subtitle}
        </Type>
      )}

      {text && (
        <Type
          as="p"
          variant={['caption-lg', 'md:paragraph-lg']}
          className="mt-3 mb-8 text-core-gray-700"
        >
          {text}
        </Type>
      )}

      <div
        className={classNames('mt-4 grid gap-4', {
          'sm:grid-cols-2': campaigns.length >= 2,
          'lg:grid-cols-3': campaigns.length >= 3,
        })}
      >
        {campaigns.map((campaign) => (
          <CampaignCard
            key={campaign.slug}
            campaign={campaign}
            layout={campaigns.length === 1 ? 'horizontal' : 'vertical'}
          />
        ))}
      </div>
    </div>
  )
}

export default CampaignSection
